export default function CSLogoBanner() {
  return (
    <div className="flex justify-center pt-6 mt-2">
      <img
        src="https://base44.app/api/apps/69f6f4084329a31d2c3702bc/files/mp/public/69f6f4084329a31d2c3702bc/123061fd7_lecircuitenfamille.jpg"
        alt="Circuit-Slot — Le circuit en Famille"
        width="1024"
        height="682"
        loading="lazy"
        decoding="async"
        className="max-w-2xl w-full h-auto"
      />
    </div>
  );
}